// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".display-package .version-list .ms-Icon {\n  position: relative;\n  top: 2px;\n  margin-right: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
